/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

/*------------------------------------*\
    LINEAR TOGGLE MODULE
\*------------------------------------*/
class LinearToggle {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        // Find toggle elements, toggle show class on click
        var siteDropdown = self.elem.querySelector('.js-linear-site-dropdown-btn');
        var dropdown = self.elem.querySelectorAll('.js-linear-site-dropdown');
        
        if(siteDropdown) {
            siteDropdown.addEventListener('click', function () {
                dropdown[0].classList.toggle('show');
            });
        }
        
        var toggles = self.elem.querySelectorAll('.js-linear-toggle');
        var togglesDropdownLabel = self.elem.querySelector('.js-active-linear');
        var loadingOverlay = document.querySelector('.js-loading-overlay');
        var body = document.querySelector('body');
        var panels = self.elem.querySelectorAll('[data-linear]');
        var activeLinear = self.elem.getAttribute('data-active-linear');

        toggles.forEach(function (toggle) {
            var linear = toggle.getAttribute('data-toggle-linear');
            var label = toggle.textContent;

            toggle.addEventListener('click', function (evt) {
                // If the new linear is different from the active linear...
                if (linear !== activeLinear) {
                    // Enable loading overlay
                    loadingOverlay.classList.add('is-active');

                    // Disable scrolling on body
                    body.classList.add('is-no-scroll');

                    // Wait half a second, for effect innit ¯\_(ツ)_/¯
                    setTimeout(function () {
                        // Update the active linear
                        activeLinear = linear;

                        // Show/hide panels
                        panels.forEach(function (panel) {
                            var linear = panel.getAttribute('data-linear');

                            if (linear === activeLinear) {
                                panel.classList.remove('d-none');
                            }
                            else {
                                panel.classList.add('d-none');
                            }
                        });

                        // Update the dropdown label
                        togglesDropdownLabel.textContent = label;

                        // Re-enable scrolling on body
                        body.classList.remove('is-no-scroll');

                        // Disable loading overlay
                        loadingOverlay.classList.remove('is-active');
                    }, 500);
                }
            });
        });
    }
}

export default LinearToggle;